// Tools that send or publish outside the workspace. A direct model call to one of
// these is refused unless the run is non-interactive and the tool is pre-approved,
// or — for the smaller opt-in subset in DELEGATED_DIRECT_SEND_TOOL_NAMES
// (apps/api/src/lambda/agent/worker/delegatedDirectSend.ts: today
// send_dobox_source_reply and create_calendar_event) — the run is a DoBox-delegated
// instruction whose recipients are all ones the user already trusts.
export const DIRECT_SEND_GATED_TOOL_NAMES = [
  'send_slack_bot_message',
  'send_notification_email',
  'gbp_reply_review',
  'facebook_reply_comment',
  'facebook_publish_post',
  'instagram_reply_comment',
  'instagram_publish_post',
  'create_calendar_event',
  'act_on_calendar_invites',
  'send_dobox_source_reply',
] as const;

export type DirectSendGatedToolName =
  (typeof DIRECT_SEND_GATED_TOOL_NAMES)[number];

const DIRECT_SEND_GATED_TOOL_NAME_SET: ReadonlySet<string> = new Set(
  DIRECT_SEND_GATED_TOOL_NAMES,
);

export const isDirectSendGatedToolName = (
  name: unknown,
): name is DirectSendGatedToolName =>
  typeof name === 'string' && DIRECT_SEND_GATED_TOOL_NAME_SET.has(name);
